import "./AddCategory.scss";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import InputGroup from "react-bootstrap/InputGroup";

import { Form } from "react-bootstrap";

import { BsTrash } from "react-icons/bs";
import { ImUpload2 } from "react-icons/im";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import { useState, useContext } from "react";
import { swalFunc } from "../../utilities/helperFunction";
import CustomizeInputFile from "./CustomizeInputFile";
import { pathMaker } from "../../utilities/helperFunction";

export default function AccordionCat({ title, bodyItem, index, activeKey }) {
  function ContextAwareToggle({ eventKey, callback }) {
    // const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );

    // const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <button
        className="btn ms-auto btn-accordion"
        type="button"
        // style={{ backgroundColor: isCurrentEventKey ? "pink" : "lavender" }}
        onClick={decoratedOnClick}
      >
        {activeKey == eventKey ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
        {/* {children} */}
      </button>
    );
  }
  const [addProductData, setAddProductData] = useState({ name: "", file: "" });
  const inputHandler = (name, value) => {
    setAddProductData((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const deleteProduct = () => {
    console.log("deleteProduct");
  };
  const deleteCat = () => {
    console.log("deleteCat");
  };
  const addProduct = () => {
    console.log("addProduct", addProductData);
  };

  return (
    <Card className="my-3 accordion-cat">
      <Card.Header
        className="d-flex align-items-center"
        style={{ backgroundColor: "#d7d7b1", fontSize: 14 }}
      >
        <BsTrash
          color="red"
          style={{ cursor: "pointer" }}
          onClick={() =>
            swalFunc(
              `آیا از حذف دسته بندی ${title} مطمئن هستید؟`,
              deleteCat,
              "warning"
            )
          }
        />
        {title}
        <ContextAwareToggle eventKey={index} />
      </Card.Header>
      <Accordion.Collapse eventKey={index}>
        <Card.Body style={{ paddingTop: 0 }}>
          <Form.Group
            className="input-cat-container rounded-bottom px-2 py-3 d-flex file-input align-items-center justify-content-between "
            style={{ backgroundColor: "beige" }}
          >
            <div className="d-flex flex-wrap justify-content-between w-100">
              <span className="input-file ">
                {" "}
                <CustomizeInputFile
                  txt="عکس مورد نظر محصول ..."
                  Icon={ImUpload2}
                  iconTxt="انتخاب عکس"
                  id="productFile"
                  onChange={(e) => inputHandler("file", e.target.files[0])}
                />
              </span>

              <InputGroup>
                <Form.Control
                  style={{ fontSize: 14, borderRadius: "0 5px 5px 0" }}
                  type="text "
                  placeholder="نام محصول را وارد کنید..."
                  className="input-cat "
                  onChange={(e) => inputHandler("name", e.target.value)}
                />

                <InputGroup.Text
                  className=" text-center icon-cat"
                  onClick={() =>
                    swalFunc(
                      "آیا از ثبت محصول مطمئن هستید؟",
                      addProduct,
                      "warning"
                    )
                  }
                >
                  ثبت
                </InputGroup.Text>
              </InputGroup>
            </div>
          </Form.Group>

          <div className=" product-container">
            {bodyItem.map((b) => {
              return (
                <div className="position-relative m-2 single-product">
                  <img
                    src={pathMaker(b.main_img_src)}
                    className="mx-1 my-2 "
                    style={{ width: 80, height: 80 }}
                  ></img>
                  <div style={{ fontSize: 13 }}>{b.title}</div>
                  <div
                    className="position-absolute top-0 bg-danger rounded-pill d-flex"
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                    onClick={() =>
                      swalFunc(
                        `آیا از حذف ${b.title} مطمئن هستید؟`,
                        deleteProduct,
                        "warning"
                      )
                    }
                  >
                    <BsTrash
                      color="white"
                      style={{ width: 12, height: 12 }}
                      className="m-auto"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
